__turbopack_context__.v({
  "container": "OutletCard-module-scss-module__26AtXW__container",
  "outletInfo": "OutletCard-module-scss-module__26AtXW__outletInfo",
  "selected": "OutletCard-module-scss-module__26AtXW__selected",
});
